<template>
  <div id="app" style="display: inline-block">
    <el-button size="small" @click="teacherAdd" type="primary"
      >选择教师</el-button
    >
    <el-dialog
      title="名师列表"
      v-if="teacherDialog"
      :visible.sync="teacherDialog"
    >
      <el-form :inline="true" align="left" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="teacherSearch"
            size="small"
            placeholder="请输入教师姓名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click.native="searchTeacher"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click.native="closeTeacherDialog"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="teacherState"
        :data="teacherList"
        border
        :row-style="{ height: '48px' }"
        :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
        stripe
        @selection-change="teacherSelectionChange"
        class="school-main"
        ref="teacherTable"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="教师姓名"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          min-width="250"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background
          :hide-on-single-page="true"
          :current-page.sync="teacherPage"
          @size-change="teacherPagesize"
          @current-change="teacherCurrentChange"
          :page-size="teacherPagesize"
          layout="total, prev, pager, next,jumper"
          :total="teacherTotalcount"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
import { ERR_OK, BASE_URLLIST } from "@/api/index";
export default {
  data() {
    return {
      teacherList: [], //名师列表
      teacher: {}, //总选择教师
      teacherNow: [], //当前页选择教师
      teacherSearch: "", //搜索名师关键字
      teacherDialog: false, //名师列表弹窗
      teacherPage: 1, //当前页
      teacherPagesize: 10, //每页显示数量
      teacherTotalcount: 0, //列表总数
      teacherState: false, //加载状态
      teacherlId: "", //教师Id
    };
  },
  created() {},
  props: {
    schoolId: {
      type: Number,
      required: false,
      default: -1,
    },
    teachers: {
      type: Array,
      required: false,
      default: [],
    },
  },
  methods: {
    //搜索名师
    searchTeacher() {
      this.teacherPage = 1;
      this.teacherList = [];
      this.teacherTotalcount = 0;
      this.getTeacherList();
    },
    teacherAdd() {
      if (this.schoolId == 0) {
        this.$message.error("请选择直播学校");
        return false;
      }
      this.teacherDialog = true;
      this.getTeacherList();
    },
    //隐藏名师列表弹窗
    closeTeacherDialog() {
      this.$emit("teacherData", this.teacher);
      this.teacherDialog = false;
    },
    // 选中教师
    xuanze(row) {
      this.teacher = row;
    },
    teacherSelectionChange(v) {
      if (v.length > 0) {
        this.teacher = v;
      }
    },
    //获取名师列表
    getTeacherList() {
      //参数
      let params = {
        schoolId: this.schoolId,
        curPage: this.teacherPage,
        pageSize: this.teacherPagesize,
        name: this.teacherSearch,
      };
      this.teacherState = true;
      let _this = this;
      //接口
      homeApi
        .getTeacherList(params)
        .then((res) => {
          //关闭加载
          this.teacherState = false;
          let { data } = res;
          if (data.code === ERR_OK) {
            //学校列表
            let list = data.data.dataList;

            _this.teacherList = [];
            if (list.length > 0) {
              
              _this.teacherTotalcount = data.data.totalCount;
              
              _this.teacherList = list;
              if (_this.teachers.length !== 0) {
                 _this.teacherList.forEach((item) => {
                  _this.teachers.forEach((items) => {
                    if (item.id == items.id) {
                      setTimeout(()=>{
                        _this.$refs.teacherTable.toggleRowSelection(item);
                      })
                      
                    }
                  });
                });
              }
            } else {
              _this.teacherPagelast = true;
            }
          } else {
            _this.$toast.center(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //改变每页显示数量
    teacherSizeChange(val) {
      this.teacherPagesize = val;
      this.getTeacherList();
    },
    //跳转到第几页
    teacherCurrentChange(val) {
      this.teacherPage = val;
      this.getTeacherList();
    },
  },
};
</script>
<style scoped>
.page {
  margin-top: 10px;
}
.demo-form-inline {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/public/teacherDlog.vue